// components/Modals.js
import React from 'react';

const Modals = () => <></>;

export default Modals;